/**
 * File custom.js.
 *
 * Handles custom JS specifically for Einstein's base theme build.
 */
jQuery(document).ready(function ($) {
  function videoType(_arrayCount, _variables) {
    _arrayCount++;
    if (_variables.length <= _arrayCount) {
      _arrayCount = 0;
    }
    $(".block--big-banner h1 strong").fadeOut(600, function () {
      var _word = _variables[_arrayCount].trim().split("");
      var _wordCount = 0;

      $(".block--big-banner h1 strong")
        .html("&nbsp;")
        .css({ display: "block", opacity: 1 });
      var _wordInterval = setInterval(function () {
        if (_wordCount < _word.length) {
          var _wordPrev =
            _wordCount > 0 ? $(".block--big-banner h1 strong").text() : "";
          $(".block--big-banner h1 strong").text(_wordPrev + _word[_wordCount]);
          _wordCount++;
        } else {
          clearInterval(_wordInterval);
          setTimeout(function () {
            videoType(_arrayCount, _variables);
          }, 3000);
        }
      }, 50);
    });
  }

if($('.home-page-banner').length){
  var _arrayCount = 0;
  var _variables = $('input[name="banner-text-replacements"]').val().split(",");

  if (_variables.length > 0 && _variables[0] !== "") {
    setTimeout(function () {
      videoType(_arrayCount, _variables);
    }, 3000);
  }
}


  //read more on image grid

  $(".block--image-grid .read-more").click(function () {
    $(this).prev().toggleClass("show");

    if ($(this).prev().hasClass("show")) {
      $(this).text("Close Bio");
    } else {
      $(this).text("Read Bio");
    }
  });

  $('.grouping-of-links').on('click', function(){
    $('.grouping-of-links').toggleClass('show');
  });

    $('.jump-to-links a').each(function(){
      // get href #
      $(this).on('click', function(e){
        e.preventDefault();
        var href = $(this).attr('class').replace('btn btn-ghost', '').trim();
        var divhref = $('#' + href);

        if (/Mobi|Android/i.test(navigator.userAgent)) {
          // mobile!
          $('html, body').animate({ 
            scrollTop: divhref.offset().top-600 //change this value for desktop
          }, 250, "swing");
        } else {
          $('html, body').animate({ 
            scrollTop: divhref.offset().top-50 //change this value for desktop
          }, 250, "swing");
        }
      });
    });
});
